import { trackAdobeFeature } from '../../client/utils/trackers/adobe';
import getPdfViewerApplication from '../../client/utils/pdfjs/pdfViewerApplication';

const enhancementManager = () => getPdfViewerApplication().enhancementManager;

export const goToNextReference = referenceType => (dispatch, getState) => {
  enhancementManager().goToNextReference(referenceType, dispatch, getState());
};

export const goToPrevReference = referenceType => (dispatch, getState) => {
  enhancementManager().goToPrevReference(referenceType, dispatch, getState());
};

export const goToNextAuthor = () => (dispatch, getState) => {
  enhancementManager().goToNextAuthor(dispatch, getState());
  trackAdobeFeature('author-next');
};

export const goToPrevAuthor = () => (dispatch, getState) => {
  enhancementManager().goToPrevAuthor(dispatch, getState());
  trackAdobeFeature('author-previous');
};
